import { useNavigate } from "react-router-dom";
import { LogIn, LogOut, Menu, X } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import itkLogo from "../assets/itk_logo.png";

const PRIMARY_BLUE = "#1565C0";

export default function Header({
  isMobile = false,
  isSidebarOpen = false,
  onMenuToggle = () => {},
  mobileBgColor = PRIMARY_BLUE,
  mobileLeftCompact = false,
}) {
  const navigate = useNavigate();
  const { isLoggedIn, logout } = useAuth();

  const goLogin = () => {
    navigate("/");
  };

  const handleLogout = async () => {
    try {
      await logout();
      navigate("/");
    } catch (err) {
      console.error("Logout error:", err);
    }
  };

  return (
    <header
      style={{
        ...styles.header,
        ...(isMobile
          ? {
              ...styles.headerMobile,
              background: mobileBgColor,
            }
          : {}),
      }}
    >
      <div
        style={{
          ...styles.leftArea,
          ...(isMobile && mobileLeftCompact ? styles.leftCompact : {}),
        }}
      >
        {isMobile && (
          <>
            <button
              type="button"
              style={{
                ...styles.menuButton,
                ...(mobileLeftCompact ? styles.menuButtonCompact : {}),
              }}
              onClick={onMenuToggle}
              aria-label={isSidebarOpen ? "Menüyü kapat" : "Menüyü aç"}
            >
              {isSidebarOpen ? (
                <X size={18} strokeWidth={2.2} />
              ) : (
                <Menu size={18} strokeWidth={2.2} />
              )}
            </button>

            <img
              src={itkLogo}
              alt="İTK Logo"
              style={{
                ...styles.mobileLogo,
                ...(mobileLeftCompact ? styles.mobileLogoCompact : {}),
              }}
            />
          </>
        )}
      </div>

      <button
        type="button"
        style={{
          ...styles.loginButton,
          ...(isMobile ? styles.loginButtonMobile : {}),
        }}
        onClick={isLoggedIn ? handleLogout : goLogin}
      >
        <span style={styles.loginButtonInner}>
          {isLoggedIn ? (
            <>
              <LogOut size={14} strokeWidth={2.2} />
              {!isMobile && "Çıkış Yap"}
            </>
          ) : (
            <>
              <LogIn size={14} strokeWidth={2.2} />
              {!isMobile && "Giriş Yap"}
            </>
          )}
        </span>
      </button>
    </header>
  );
}

const styles = {
  header: {
    height: "72px",
    width: "min(720px, calc(100% - 32px))",
    marginLeft: "auto",
    color: "#ffffff",
    padding: "0 20px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    borderRadius: "16px",
    background: "transparent",
    position: "fixed",
    top: "12px",
    right: "16px",
    zIndex: 80,
    boxSizing: "border-box",
  },

  headerMobile: {
    width: "100%",
    left: 0,
    right: 0,
    top: 0,
    marginLeft: 0,
    padding: "0 16px",
    borderRadius: 0,
  },

  leftArea: {
    display: "flex",
    alignItems: "center",
    gap: 10,
    minWidth: "fit-content",
  },

  leftCompact: {
    gap: 6,
  },

  menuButton: {
    width: "40px",
    height: "40px",
    borderRadius: "12px",
    border: "none",
    background: "rgba(255,255,255,0.15)",
    color: "#ffffff",
    cursor: "pointer",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
  },

  menuButtonCompact: {
    width: "34px",
    height: "34px",
    borderRadius: "10px",
  },

  mobileLogo: {
    height: "36px",
    width: "36px",
    objectFit: "contain",
    background: "#ffffff",
    borderRadius: "10px",
    padding: "4px",
    boxSizing: "border-box",
    flexShrink: 0,
  },

  mobileLogoCompact: {
    height: "28px",
    width: "28px",
    padding: "2px",
    borderRadius: "8px",
  },

  loginButton: {
    marginLeft: "auto",
    minWidth: "112px",
    height: "42px",
    padding: "0 18px",
    borderRadius: "12px",
    border: "1px solid rgba(255,255,255,0.22)",
    background: PRIMARY_BLUE,
    color: "#ffffff",
    fontSize: "14px",
    fontWeight: 600,
    cursor: "pointer",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
  },

  loginButtonMobile: {
    minWidth: "unset",
    height: "34px",
    padding: "0 10px",
    fontSize: "13px",
    background: "#ffffff",
    color: PRIMARY_BLUE,
    border: "1px solid rgba(255,255,255,0.3)",
  },

  loginButtonInner: {
    display: "flex",
    alignItems: "center",
    gap: 6,
    whiteSpace: "nowrap",
  },
};